import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { BillingDataBuilder } from './billing-data.builder';
import { map } from 'rxjs/operators';
import { RenewalInfo } from './models/renewal-info.model';

const PATHS = {
  AUTO_RENEW: 'renewal_info',
};

@Injectable()
export class BillingDataService {
  constructor(
    private _authHttpService: AuthHttpService,
    private _billingDataBuilder: BillingDataBuilder
  ) {}

  getAutoRenew(): Observable<RenewalInfo> {
    const { url } = this._billingDataBuilder.buildSubscriptionUrl(
      PATHS.AUTO_RENEW
    );

    return this._authHttpService
      .get(url)
      .pipe(map(({ body }: IResponseInfo) => new RenewalInfo(body)));
  }
}
